import { MetricsApi } from 'api'

export const sendInitEvent = (payload: Record<string, any>) => MetricsApi.post(`/monitoring/metrics/widget/init/v2`, payload)

export const bulkSendMetrics = (metrics: Record<string, any>[]) => MetricsApi.post('/monitoring/metrics/add/bulk', metrics)

export const bulkSendUsageMetrics = (payload: Record<string, any>) => MetricsApi.post(`/monitoring/metrics/event2/bulk`, payload)
